module.exports = __webpack_public_path__ + "img/emoji-frown.714dcbbb.svg";